const CART_MODE = 'cart_mode';
const AUTH_MODE = 'auth_mode';
const CONFIRM_SALE_MODE = 'confirm_sale_mode';
const PAYMENT_MODE = 'payment_mode';
const BUYER_INFO_EXTRATION_MODE = 'buyer_info_extration_mode';
const SUCCESSFUL_PAYMENT = 'successful_payment';
const SALE_MODE = 'sale_mode';

export {
  CART_MODE,
  AUTH_MODE,
  CONFIRM_SALE_MODE,
  PAYMENT_MODE,
  BUYER_INFO_EXTRATION_MODE,
  SUCCESSFUL_PAYMENT,
  SALE_MODE,
};
